import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import TagsPage from 'flarum/tags/components/TagsPage';
import type Tag from 'flarum/tags/models/Tag';

import './emoji/index';

app.initializers.add('blomstra/client-ext-gofeminin', () => {
  if ('flarum-tags' in flarum.extensions) {
    extend(TagsPage.prototype, 'tagTileView', function (vnode, tag: Tag) {
      // Add a unique class to the tag tile using both the tag ID and the tag slug.
      vnode.attrs.className += ` TagTile--${tag.id()} TagTile--${tag.slug()}`;
    });
  }
});
